module.exports = __webpack_public_path__ + "media/images/shared/suppliers/GARRETT-b918b0c5546553a0a16338cd523399b5.jpg";